import useMediaQuery from '@mui/material/useMediaQuery'

// Single source of truth for the phone breakpoint, mirroring the @media (max-width: 768px) rule in
// style.css. Used to stack the multi-column row editors and to show per-row field labels on narrow
// screens (on desktop the first row's labels serve as column headers).
export const MOBILE_MEDIA_QUERY = '(max-width:768px)'

export default function useIsMobile(): boolean {
    return useMediaQuery(MOBILE_MEDIA_QUERY)
}
